import React from 'react';
import './index.scss';

const StickyTopWrapper = () => {
  return <div id="sticky-top-wrapper" className="sticky-top-wrapper"></div>;
};

export default StickyTopWrapper;
